import { type MaybeRef, toValue } from "vue";

export const timeout = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const waitFor = (
  checkFunction: () => boolean,
  totalChecks = 10,
  timeBetweenChecksInMs = 1000,
): Promise<void> =>
  new Promise((resolve, reject) => {
    let checksDone = 0;
    const intervalId = setInterval(() => {
      if (checkFunction()) {
        clearInterval(intervalId);
        resolve();
        return;
      }

      if (checksDone >= totalChecks) {
        clearInterval(intervalId);
        reject();
        return;
      }

      checksDone += 1;
    }, timeBetweenChecksInMs);
  });

export const waitForThirdParty = (
  windowFieldName: string,
  totalChecks?: number,
  timeBetweenChecksInMs?: number,
) =>
  waitFor(
    () =>
      Boolean(
        (window as typeof window & Record<string, undefined | unknown>)[
          windowFieldName
        ],
      ),
    totalChecks,
    timeBetweenChecksInMs,
  );

export const waitForValue = (
  value: unknown | MaybeRef<unknown>,
  totalChecks?: number,
  timeBetweenChecksInMs?: number,
) => waitFor(() => Boolean(toValue(value)), totalChecks, timeBetweenChecksInMs);
